export class BusinessIncentiveProjectInfo {
  deptOfLaborInsuranceId: string;
  deptOfLaborInsuranceReason: string;
  deptOfRevenueId: string;
  deptOfRevenueReason: string;
  fiscalYear: string;
  naicsCode: string;
  naicsCodeReason: string;
  projectDescription: string;
  projectEndDate: Date;
  projectStartDate: Date;
  projectType: string;
  commencementDate: Date;
  isOperationalBeforeCompletion: boolean;
  calendarYears: string[];
  isMultiAddressDescription: string;
  isMultiStructure: boolean;
  isMultiAddress: boolean;
  hasDeptOfRevenueId: boolean;
  hasDeptOfLaborInsuranceId: boolean;
  hasNaicsCode: boolean;
  isRehabOrRestore: boolean;
  isQualifiedDisaster: boolean;
  isFileBeforeConstruction: boolean;
  hasExcludedProperty: boolean;
  hasExcludedCapitalUpgrades: boolean;
  hasExcludedMaintenanceCapital: boolean;
  hasExcludedMiscAdditions: boolean;
  hasExcludedReplacements: boolean;
  projectBenefit: string;
  constructionActivities: string;
  machineryExamples: string;

  constructor(info?: any) {
    info = info || {};
    this.deptOfLaborInsuranceId = info.deptOfLaborInsuranceId || null;
    this.deptOfRevenueId = info.deptOfRevenueId || null;
    this.deptOfRevenueReason = info.deptOfRevenueReason || null;
    this.fiscalYear = info.fiscalYear || null;
    this.naicsCode = info.naicsCode || null;
    this.projectDescription = info.projectDescription || null;
    this.projectEndDate = info.projectEndDate
      ? new Date(info.projectEndDate)
      : null;
    this.projectStartDate = info.projectStartDate
      ? new Date(info.projectStartDate)
      : null;
    this.projectType = info.projectType || null;
    this.calendarYears = info.calendarYears || [];
    this.isOperationalBeforeCompletion = info.isOperationalBeforeCompletion ;
    this.commencementDate = info.commencementDate
      ? new Date(info.commencementDate)
      : null;

    this.isMultiAddressDescription = info.isMultiAddressDescription;
    this.isMultiStructure = info.isMultiStructure;
    this.isMultiAddress = info.isMultiAddress;
    this.hasDeptOfRevenueId = info.hasDeptOfRevenueId;
    this.deptOfRevenueReason = info.deptOfRevenueReason;
    this.hasDeptOfLaborInsuranceId = info.hasDeptOfLaborInsuranceId;
    this.deptOfLaborInsuranceReason = info.deptOfLaborInsuranceReason;
    this.hasNaicsCode = info.hasNaicsCode;
    this.naicsCodeReason = info.naicsCodeReason;
    this.isRehabOrRestore = info.isRehabOrRestore;
    this.isQualifiedDisaster = info.isQualifiedDisaster;
    this.isFileBeforeConstruction = info.isFileBeforeConstruction;
    this.hasExcludedProperty = info.hasExcludedProperty;
    this.hasExcludedCapitalUpgrades = info.hasExcludedCapitalUpgrades;
    this.hasExcludedMaintenanceCapital = info.hasExcludedMaintenanceCapital;
    this.hasExcludedMiscAdditions = info.hasExcludedMiscAdditions;
    this.hasExcludedReplacements = info.hasExcludedReplacements;
    this.projectBenefit = info.projectBenefit;
    this.constructionActivities = info.constructionActivities;
    this.machineryExamples = info.machineryExamples;
  }
  }

